import { getEntityPatterns } from "./emptyEntities";
import {getSystemEntityById, SystemEntity} from "./SystemEntity";
import {BOOL_ENTITY_TYPE, boolEntityContractTextValue, boolEntityOmitsContractText, fullEntityValue} from "./workWithEntities";
import { forEachSelectedObjectInnerField, getObjectInnerFieldValue } from "./workWithObjectEntity";
import {photoHtmlFromValue} from "./photoFieldHtml";
import {replaceDataImageSrcsWithBlobUrls} from "./editorPhotoSrc";

export function updateEntityInEditorBySystemEntityId(id: string, value: string, otherEntities: any[] = [], signerPrefix?: string) {
    let entity = getSystemEntityById(id)
    if (entity) {
        updateEntityInEditorBySystemEntity(entity, value, otherEntities, signerPrefix)
    }
}

export function updateEntityInEditorBySystemEntity(entity: SystemEntity, value: string, otherEntities: any[] = [], signerPrefix?: string) {
    let entityWithValue = {
        ...entity,
        value: value
    }
    updateEntityInEditor(entityWithValue, otherEntities, signerPrefix)

    entityWithValue.keyword = entityWithValue.id
    updateEntityInEditor(entityWithValue, otherEntities, signerPrefix)
}

export function updateEntityInEditor(entity: any, otherEntities: any[] = [], signerPrefix?: string, onlyInnerKeyword?: string) {
    if (entity.type === "PDF") return;
    const effectiveKeyword = signerPrefix ? `${signerPrefix}.${entity.keyword}` : entity.keyword
    let {normalPattern, escapedPattern, rawPattern} = getEntityPatterns(effectiveKeyword)
    let kw = rawPattern
    for (let name of [normalPattern, escapedPattern]) {
        document.getElementsByName(name).forEach((element: HTMLElement) => {
            let displayValue = entity.type === BOOL_ENTITY_TYPE
                ? boolEntityContractTextValue(entity)
                : fullEntityValue(entity, "\n", otherEntities)
            if (entity.type === "Фото") {
                if (element.tagName === "SPAN" && element.parentNode) {
                    const div = document.createElement("div")
                    for (const attr of Array.from(element.attributes)) {
                        div.setAttribute(attr.name, attr.value)
                    }
                    element.parentNode.replaceChild(div, element)
                    element = div
                }
                displayValue = photoHtmlFromValue(displayValue)
            }
            // У «Таблица» value всегда '', данные в entity.table — placeholder по value ломает HTML.
            const usePlaceholder = boolEntityOmitsContractText(entity)
                ? false
                : entity.type === BOOL_ENTITY_TYPE || entity.type === "Таблица"
                    ? !displayValue?.trim()
                    : (entity.value ?? "")?.length == 0
            // client_fio — computed поле: entity.value пустой, но в DOM может быть уже подставленное ФИО.
            // Не заменяем на placeholder, если элемент уже содержит осмысленный текст (не {{...}}).
            const isClientFio = entity.id === "client_fio" || entity.keyword === "ФИО клиента"
            const hasMeaningfulContent = element.innerHTML?.trim() && !element.innerHTML.includes("{{")
            if (isClientFio && usePlaceholder && hasMeaningfulContent) {
                return // сохраняем текущее содержимое
            }
            element.innerHTML = replaceDataImageSrcsWithBlobUrls(usePlaceholder ? kw : displayValue);
        })
    }
    if (entity?.type !== "Объект") {
        return
    }
    forEachSelectedObjectInnerField(otherEntities, (_objectEntity, _innerEntity, fullKeyword) => {
        const {normalPattern, escapedPattern, rawPattern} = getEntityPatterns(fullKeyword)
        for (let name of [normalPattern, escapedPattern]) {
            document.getElementsByName(name).forEach((element: HTMLElement) => {
                let value = getObjectInnerFieldValue(otherEntities, fullKeyword) ?? ""
                element.innerHTML = replaceDataImageSrcsWithBlobUrls(value.length == 0 ? rawPattern : value)
            })
        }
    }, entity.keyword, onlyInnerKeyword)
}